<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-img width="100%" :src="require('@/assets/keyvisual.jpg')"></v-img>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <v-text-field v-model="name" :rules="nameRules" label="ชื่อ-นามสกุล*" prepend-inner-icon="fas fa-street-view"
            color="primary" outlined required></v-text-field>

          <v-menu ref="menu" :close-on-content-click="false" transition="scroll-y-transition" min-width="300px"
            required>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFormattedMomentjs" prepend-inner-icon="fas fa-birthday-cake"
                label="วันเกิด*" v-on="on" v-bind="attrs" :rules="dateRules" outlined readonly></v-text-field>
            </template>
            <v-date-picker locale="th-TH" ref="picker" v-model="date" :rules="dateRules"
              :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @change="save"></v-date-picker>
          </v-menu>

          <p class="text-left ptext">
            <i class="fas fa-transgender-alt pr-2"></i>เพศ
          </p>
          <v-radio-group row v-model="gender" :rules="genderRules" required>
            <v-radio color="#DD2C00" label="ชาย" value="male"></v-radio>
            <v-radio color="#DD2C00" label="หญิง" value="female"></v-radio>
            <v-radio color="#DD2C00" label="ไม่ระบุ" value="other"></v-radio>
          </v-radio-group>

          <v-text-field v-model="email" label="อีเมล*" :rules="emailRules" prepend-inner-icon="fas fa-envelope"
            color="primary" outlined></v-text-field>

          <v-text-field v-model="mobile" :rules="mobileRules" outlined label="เบอร์มือถือ*"
            prepend-inner-icon="fas fa-mobile-alt" color="primary" maxlength="10" required></v-text-field>

          <v-select v-model="province" :items="provinceItems" :rules="[(v) => !!v || 'กรุณาระบุจังหวัด']" outlined
            prepend-inner-icon="fas fa-map-marker-alt" label="จังหวัด*" color="primary" required></v-select>

          <v-select v-model="categorys" :items="categoryItems" :rules="[(v) => !!v || 'กรุณาเลือกประเภทสินค้าที่ชอบ']"
            outlined prepend-inner-icon="far fa-thumbs-up" label="คุณต้องการช้อปสินค้าประเภทใด*" color="primary"
            required></v-select>

          <v-checkbox v-model="checkbox" :rules="[(v) => !!v || 'กรุณาอ่าน และคลิกยอมรับเงื่อนไขกิจกรรม']"
            color="primary" required>
            <template v-slot:label color="primary">
              ข้าพเจ้ายอมรับ&nbsp;
              <a href="#" class="blue--text" @click.stop.prevent="(dialog = true), (dialogPolicy = true)">
                เงื่อนไข
              </a>
              &nbsp; ของกิจกรรม
            </template>
          </v-checkbox>

          <v-btn block :disabled="!formValid" color="primary" class="pa-4 text-capitalize" @click="validate">
            <i class="fas fa-sign-in-alt pe-1"></i>SUBMIT
          </v-btn>
        </v-form>

        <!-- dialog insert OTP -->

        <!-- <v-card-title class="headline"> -->
        <v-dialog v-model="dialogInsertOTP" persistent max-width="600" :key="componentKey">
          <v-card justify="center">
            <v-card-title class="headline purple darken-1" primary-title>
              <v-col align="center" justify="center">
                <v-img :src="require('@/assets/modalLog.png')" class="responsive"></v-img>
              </v-col> </v-card-title><br />
            <v-card-text class="headline">
              {{ textOTP }}
            </v-card-text>

            <v-card-actions v-show="dialogMaximun">
              <v-col align="center" justify="center">
                <div class="ma-auto" style="max-width: 300px">
                  <v-otp-input v-model="verifyRequest.code" :rules="otpRules" length="6" required
                    type="number"></v-otp-input>
                </div>
                <div>
                  Expire Time
                  <span class="font-weight-bold">
                    <BaseTimer />
                  </span>
                </div>
              </v-col>
            </v-card-actions>

            <v-card-actions>
              <v-col align="center" justify="center">
                <v-btn color="black darken-1 white--text" @click="confirmOTP" :disabled="!dialogMaximun">
                  Agree
                </v-btn>
              </v-col>
              <v-col align="center" justify="center">
                <v-btn color="grey darken-1 white--text" @click="closeDialog">
                  Cancel
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialog Phone Number is not use  -->

        <v-dialog v-model="dialogPhoneNumberDulicate" max-width="500">
          <v-card justify="center">
            <v-card-title class="headline purple darken-1" primary-title>
              <v-col align="center" justify="center"><v-img :src="require('@/assets/modalLog.png')"
                  class="responsive"></v-img></v-col> </v-card-title><br />
            <v-card-text>
              <p class="modal">เบอร์โทรศัพท์นี้ ถูกลงทะเบียนแล้ว !!</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogPhoneNumberDulicate = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ------------------ -->

        <v-dialog v-model="dialogFirst" absolute max-width="100%" persistent>
          <v-card>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-col cols="6" sm="4">
                <div align="center">
                  <v-img :src="require('@/assets/modalLogb.png')" class="res"></v-img>
                </div>
              </v-col>
            </v-row>
            <v-card-text class="pt-2">
              <p class="subtitle-1">
                <strong>นโยบายความเป็นส่วนตัว</strong>
                <!-- (ระยะเวลากิจกรรมตั้งแต่ 1 ม.ค. - 26 มิ.ย. 63 จับรางวัล 4 ครั้ง และทบฉลากทุกครั้ง) -->
              </p>
              <p class="textspace">
                บริษัท สยามพิวรรธน์ ไซม่อน จำกัด ("<strong>บริษัทฯ</strong>", "
                <strong>เรา</strong>" หรือ "<strong>ของเรา</strong>")
                เล็งเห็นถึงความสำคัญของการคุ้มครองสิทธิของท่านในข้อมูลใด ๆ
                ที่เกี่ยวข้องกับบุคคลธรรมดาซึ่งถูกระบุหรือสามารถถูกระบุได้ ("
                <strong>ข้อมูลส่วนบุคคล</strong>") จากผลิตภัณฑ์และบริการของเรา
                เราทราบดีว่าท่านต้องการที่จะได้รับการคุ้มครองตามมาตรฐานที่ระบุโดยกฎหมายไทยที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคลในส่วนของวิธีการที่เราเก็บ
                รวบรวม ใช้ เปิดเผย และ/หรือ โอนข้อมูลของท่านไปยังต่างประเทศ
                ข้อมูลที่ท่านให้กับเรานั้นทำให้เราสามารถมอบผลิตภัณฑ์และให้บริการที่ตรงกับความต้องการเฉพาะสำหรับท่านอย่างเหมาะสม
                ทั้งจากเราและบริษัทที่อยู่ในกลุ่มสยามพิวรรธน์
                เรามีมาตรการการคุ้มครองข้อมูลส่วนบุคคลซึ่งรวมถึงการคุ้มครองมิให้ข้อมูลส่วนบุคคลของท่านถูกใช้โดยมิได้รับความยินยอมจากท่านก่อน
              </p>
              <p class="textspace">
                นโยบายความเป็นส่วนตัวฉบับนี้
                <strong>("นโยบายความเป็นส่วนตัว")</strong> ใช้กับร้านค้าปลีก
                เว็บไซต์ แอปพลิเคชันบนโทรศัพท์มือถือ ช่องทางสื่อสังคมออนไลน์
                ช่องทางการสื่อสารทางออนไลน์ บริการการแลกเปลี่ยนคะแนนสะสม
                งานและกิจกรรม ตลอดจนสถานที่อื่น ๆ
                ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม
                กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับบริการเฉพาะดังกล่าวที่ท่านใช้
                ซึ่งอาจมีข้อตกลงและเงื่อนไขต่างหากเกี่ยวกับข้อมูลส่วนบุคคลของท่านที่เราเก็บไว้
              </p>
              <p class="textspace">
                บริษัทฯ
                ขอสงวนสิทธิในการแก้ไขนโยบายความเป็นส่วนตัวนี้เมื่อบริษัทฯเห็นว่ามีความจำเป็น
                ซึ่งอาจมีหรือไม่มีการแจ้งล่วงหน้า ดังนั้น
                โปรดอ่านนโยบายความเป็นส่วนตัวนี้ทุกครั้งก่อนทำธุรกรรมกับเรา
                โดยเราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงในสาระสำคัญ

                <br /><br /><strong>1. ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong>

                เราอาจมีการเก็บรวบรวม รักษา และใช้ข้อมูลประเภทดังต่อไปนี้
                ซึ่งอาจรวมไปถึงข้อมูลส่วนบุคคลของท่านโดยตรงหรือโดยอ้อมจากท่านหรือแหล่งข้อมูลอื่น
                ๆ หรือจากบริษัทในเครือ บริษัทย่อย พันธมิตรทางธุรกิจ
                หรือการสื่อสารระหว่างเรา
                โดยลักษณะของข้อมูลส่วนบุคคลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารและความสัมพันธ์ของเรากับท่าน
                รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและกลุ่มสยามพิวรรธน์
              </p>
              <p class="textspaceB">
                <strong> 1) ข้อมูลส่วนตัว</strong>
                ได้แก่ คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ หมู่เลือด สัญชาติ วันเกิด
                ประวัติการศึกษา อาชีพ ตำแหน่งงาน สถานที่ทำงาน
                ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน
                เลขหนังสือเดินทาง ข้อมูลใบอนุญาตขับขี่รถยนต์
                บัตรประจำตัวเจ้าหน้าที่ของรัฐ
                หรือเอกสารระบุตัวตนที่มีลักษณะเดียวกัน เป็นต้น) รูปถ่าย
                ภาพจากกล้องวงจรปิด ข้อมูลยานพาหนะ (เช่น สำเนาหนังสือทะเบียนรถ
                เลขทะเบียนรถ ยี่ห้อ และ สี) และข้อมูลทางกายภาพอื่น ๆ เป็นต้น
              </p>
              <p class="textspaceB">
                <strong>2) ข้อมูลเพื่อการติดต่อ</strong>
                ได้แก่ ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง
                ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ ที่อยู่อีเมล
                ชื่อบัญชีผู้ใช้แอปพลิเคชันไลน์ (LINE ID)
                และชื่อบัญชีผู้ใช้ในเว็บไซต์สื่อสังคมออนไลน์อื่น ๆ
              </p>
              <p class="textspaceB">
                <strong>3) ข้อมูลทางการเงิน</strong>
                ได้แก่ ข้อมูลบัตรเครดิต (เช่น ชื่อ และ หมายเลขบนบัตรเครดิต)
                สถานะทางการเงิน เงินเดือน และ ข้อมูลทางการเงินอื่น ๆ
              </p>
              <p class="textspaceB">
                <strong>4) </strong>
                <strong>ข้อมูลการทำธุรกรรม</strong>
                เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน
                วันที่และเวลาที่ชำระเงิน สิ่งของที่ซื้อ ยอดชำระเงิน
                สถานที่ที่ซื้อสินค้าหรือบริการ
                ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ
                ใบเสร็จ ใบแจ้งหนี้ ประวัติการทำธุรกรรม และ สถานะของธุรกรรม
              </p>
              <p class="textspaceB">
                <strong>5) ข้อมูลและรายละเอียดด้านระบบคอมพิวเตอร์ เครื่องมือ และ
                  อุปกรณ์</strong>
                เช่น ชื่อผู้ใช้ PIN อุปกรณ์ที่ใช้ ที่ตั้งทางภูมิศาสตร์
                ระบบที่ใช้ดำเนินงาน ข้อมูลเครือข่ายของโทรศัพท์เครื่องที่
                ข้อมูลการใช้งานคอมพิวเตอร์
                ข้อมูลการเรียกดูบริการบนเว็บไซต์และแอปพลิเคชัน (เช่น
                ประวัติการค้นหา วันที่ เวลา)
              </p>
              <p class="textspaceB">
                <strong>6) ข้อมูลเกี่ยวกับพฤติกรรม </strong>
                เช่น ข้อมูลเกี่ยวกับพฤติกรรมของท่าน วิถีการดำเนินชีวิต
                ความคิดเห็น การสื่อสารโต้ตอบ
                และข้อมูลตำแหน่งของท่านภายในอาคารของเรา
              </p>
              <p class="textspaceB">
                <strong>7) ข้อมูลการเป็นสมาชิก </strong>
                ได้แก่ หมายเลขบัตรสมาชิก รหัสสมาชิก หรือ ชื่อผู้ใช้
                พฤติกรรมการใช้จ่าย และข้อมูลอื่น ๆ
                เกื่ยวกับผลิตภัณฑ์และสินค้าที่ท่านได้ซื้อ ยื่นเรื่องร้องเรียน
                เรียกร้องสิทธิ ติชม และ ให้คำแนะนำ
              </p>
              <p class="textspaceB">
                <strong>8) ข้อมูลทางการตลาดและการติดต่อสื่อสา</strong>
                ร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา
                บริษัทในเครือ บริษัทย่อย บุคคลที่สาม พันธมิตรทางธุรกิจ
                และรูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ
              </p>

              <p class="textspaceB">
                <strong>9) ข้อมูลที่อ่อนไหว </strong>
                เช่น ศาสนา ข้อมูลสุขภาพ (เช่น อาหารที่แพ้) เชื้อชาติ ชาติพันธุ์
                และประวัติอาชญากรรม
              </p>
              <p class="textspace">
                หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา (เช่น ชื่อ
                นามสกุล ที่อยู่ หมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน
                รายได้ของบุคคลในครอบครัว)
                กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้
                และ/หรือขอความยินยอมจากบุคคลเหล่านั้น หากสามารถทำได้
                เราจะเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลที่อ่อนไหวก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน
                หรือในกรณีที่กฎหมายอนุญาตให้ดำเนินการได้
              </p>
              <p class="textspace">
                เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ
                คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้แทนโดยชอบธรรม
                ผู้พิทักษ์ หรือผู้อนุบาลของผู้เยาว์ เท่านั้น
                เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี
                หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถ
                หากไม่ได้รับความยินยอมจากผู้แทนโดยชอบธรรม ผู้พิทักษ์
                หรือผู้อนุบาล ในกรณีที่จำเป็นต้องได้รับความยินยอม
                ในกรณีที่เราทราบว่า
                เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ
                ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ
                หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้แทนโดยชอบธรรม
                ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที
                หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น
                ๆ นอกเหนือจากการขอความยินยอม
              </p>
              <p class="ptext">
                <strong>
                  2. เหตุใดเราจึงเก็บรวบรวม ใช้
                  หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                </strong>
                <strong></strong>
              </p>
              <p class="textspace">
                <strong>2.1 วัตถุประสงค์ที่ต้องได้รับความยินยอมจากท่าน</strong>
              </p>
              <p class="textspaceB">
                <strong>1) การตลาดและการติดต่อสื่อสาร</strong> :
                เพื่อติดต่อสื่อสารด้านการตลาด มอบสิทธิพิเศษ การลดราคา
                การประชาสัมพันธ์ การแจ้งเตือน ข่าวสาร โปรโมชัน ข้อเสนอพิเศษ
                แคมเปญ งานอีเว้นท์ กิจกรรมทางการตลาด การโฆษณา และการตลาดทางตรง
                และ<strong>ข้อมูล</strong>
                เกี่ยวกับผลิตภัณฑ์และบริการจากเรา กลุ่มสยามพิวรรธน์
                บริษัทในเครือ บริษัทย่อย และ/หรือพันธมิตรทางธุรกิจของเรา
                ซึ่งเราไม่สามารถอาศัยฐานทางกฎหมายอื่น
              </p>
              <p class="textspaceB">
                <strong>2) ข้อมูลส่วนบุคคลที่อ่อนไหว</strong>:
              </p>
              <p class="textspaceB">
                <strong>(1) ศาสนา:</strong>
                เพื่อการยืนยันตัวบุคคลและเพื่อให้บริการ (เช่น การจัดเตรียมอาหาร)
              </p>
              <p class="textspaceB">
                <strong>(2) ข้อมูลสุขภาพ:</strong> (เช่น อาหารที่แพ้)
                เพื่อการจัดเตรียมอาหาร
              </p>
              <p class="textspaceB">
                <strong>(3) เชื้อชาติ:</strong> เราอาจเก็บข้อมูลเชื้อชาติ
                ชาติพันธุ์ของท่านในบางกรณี เช่น จากใบสมัคร Tourist Card
                เราจะไม่ใช้ข้อมูลในทางที่สามารถบ่งบอกตัวตนของท่านได้ไม่ว่าทางตรงหรือทางอ้อม
                และอาจใช้ข้อมูลนี้ในรูปแบบไม่ระบุตัวตนเพื่อนำไปประกอบรายงานทางธุรกิจ
                หรือ รายงานการพยากรณ์ความต้องการ
              </p>
              <p class="textspaceB">
                <strong>(4) ประวัติอาชญากรร:</strong>
                เพื่อความปลอดภัยและป้องกันการทุจริตและฉ้อโกง
              </p>
              <p class="textspace">
                <strong>2.2. วัตถุประสงค์และฐานทางกฎหมายอื่น
                  ๆที่เราใช้เพื่อการประมวลผลข้อมูลส่วนบุคคลของท่าน</strong>
              </p>
              <p class="textspace">
                เราอาจอาศัย (1)
                ฐานทางสัญญาในการเข้าทำสัญญาหรือการปฏิบัติตามสัญญากับท่าน (2)
                หน้าที่ตามกฎหมาย เพื่อการปฏิบัติหน้าที่ตามกฎหมาย (3)
                ประโยชน์โดยชอบด้วยกฎหมายของเราและของบุคคลภายนอก (4)
                ประโยชน์ซึ่งจำเป็นเพื่อการป้องกันหรือระงับอันตรายต่อชีวิต
                ร่างกาย หรือสุขภาพของบุคคล และ/หรือ (5) ประโยชน์สาธารณะ
                สำหรับการดำเนินภารกิจเพื่อประโยชน์สาธารณะ
                หรือการใช้สิทธิของเจ้าหน้าที่ของรัฐ เราอาจเก็บรวบรวม ใช้
                และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้
              </p>
              <p class="textspaceB">
                <strong>1) เพื่อจัดหาผลิตภัณฑ์และบริการให้แก่ท่าน</strong>
                เพื่อเข้าทำสัญญาที่เป็นลายลักษณ์อักษรหรือไม่เป็นลายลักษณ์อักษรและจัดการความสัมพันธ์ตามสัญญาระหว่างเรากับท่าน
                เพื่อสนับสนุนการสมัครสมาชิก สมัครใช้บัตร การใช้จ่ายและเปิดใช้งาน
                และดำเนินกิจกรรมอื่น ๆ ที่เกี่ยวข้องกับรายละเอียดตามสัญญา
                ธุรกรรมทางการเงินและบริการที่เกี่ยวข้องกับการชำระเงิน
                เพื่อรายงานสถานะคำสั่งซื้อของท่าน
                การแจ้งเตือนวันหมดอายุของบัตรสมาชิกและบัตรกำนัลของท่าน
                การตรวจสอบยอดบัตรและคะแนนสะสม
                การให้บริการที่เกี่ยวข้องกับผลิตภัณฑ์ทางการเงิน กู้เงินธนาคาร
                การจัดการสินทรัพย์ การลงทุน ประกัน ธุรกรรมทางอิเล็กทรอนิกส์
                บัตรเครดิต บัตรเงินสด ทรัพย์สิน การจัดส่งสินค้า บริการขนส่ง
                บริการด้านท่องเที่ยวและบริษัทนำเที่ยว การออกใบแจ้งหนี้และใบเสร็จ
                การเปลี่ยนหรือส่งคืนสินค้า และการคืนเงิน
                การแลกคะแนนสะสมเป็นของสมนาคุณ การอนุญาติการเชื่อมต่อและให้บริการ
                Wi-Fi ฟรี การให้บริการที่จอดรถ
                และการอนุญาตให้ออกจากอาคารในกรณีที่บัตรจอดรถหาย
                การให้บริการท่านในการเดินทางเชิงธุรกิจ
                การส่งหรือคืนของหายของท่าน การให้บริการหลังการขาย
              </p>
              <p class="textspaceB">
                <strong>2) การตลาดและการติดต่อสื่อสาร</strong>
                เพื่อติดต่อสื่อสารด้านการตลาด มอบสิทธิพิเศษ การลดราคา
                การประชาสัมพันธ์ การแจ้งเตือน ข่าวสาร โปรโมชั่น ข้อเสนอพิเศษ
                แคมเปญ งานอีเว้นท์ กิจกรรมทางการตลาด การโฆษณา และการตลาดทางตรง
                และข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการจากเรา กลุ่มสยามพิวรรธน์
                บริษัทในเครือ บริษัทย่อย และ/หรือพันธมิตรทางธุรกิจของเรา
              </p>
              <p class="textspaceB">
                <strong>3) โปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty Programs)
                  โปรแกรมการสะสมคะแนน (Rewarding Programs) การจับรางวัล
                  และข้อเสนออื่น ๆ เพื่อการแสดงสินค้า การจัดสรรและสนับสนุน
                  กิจกรรมพิเศษ การสะสมและแลกคะแนนตามโปรแกรม การจับฉลาก
                  และบริการที่เกี่ยวข้องอื่น ๆ</strong>
              </p>
              <p class="textspaceB">
                <strong>4) การแนะนำและการจัดการให้เหมาะสมกับบุคคล</strong>
                เพื่อแนะนำผลิตภัณฑ์และบริการที่ท่านอาจจะสนใจ
                ทราบถึงความต้องการของท่าน
                และดำเนินการให้ท่านได้รับผลิตภัณฑ์และบริการที่เหมาะสมกับท่าน
              </p>
              <p class="textspaceB">
                <strong>5) การลงทะเบียนและการยืนยันตัวตน</strong>
                เพื่อลงทะเบียน ยืนยัน ระบุและ/หรือ รับรองท่านหรือตัวตนของท่าน
              </p>
              <p class="textspaceB">
                <strong>6) เพื่อติดต่อและสื่อสารกับท่าน</strong>
                เพื่อสื่อสารกับท่านในเชิงการตลาด การลดราคา สิทธิพิเศษ โปรโมชั่น
                การแจ้งเตือน ข่าวสาร แคมเปญ งานอีเว้นท์ กิจกรรมทางการตลาด
                การโฆษณา การตลาดทางตรง และข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการ
                เพื่อการให้ข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการจากเรา
                กลุ่มสยามพิวรรธน์ บริษัทในเครือ บริษัทย่อย
                และ/หรือพันธมิตรทางธุรกิจของเรา
                ที่เกี่ยวข้องกับผลิตภัณฑ์และการบริการที่ท่านได้รับจากเรา
                เพื่อประมวลและปรับข้อมูลของลูกค้าให้เป็นปัจจุบัน
                และรองรับคำถามเกี่ยวกับการบริการลูกค้า คำขอ ข้อเสนอแนะ
                การร้องเรียน การใช้สิทธิประกัน ข้อพิพาท
                หรือการกำหนดจ่ายค่าสินไหมทดแทน
              </p>
              <p class="textspaceB">
                <strong>7) การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรมของลูกค้า</strong>
                (Profiling) และการวิเคราะข้อมูล (Data Analytics)
                เพื่อวิเคราะห์ข้อมูลส่วนบุคคลของท่าน (เช่น พฤติกรรม
                ผลิตภัณฑ์และบริการที่ซื้อ ราคา สถานที่)
                สำหรับกิจกรรมทางด้านการตลาด และการพัฒนาผลิตภัณฑ์และบริการ
                การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรม (Profiling)
                และการทำความสะอาดข้อมูล (Data Cleansing)
                เพื่อทำการค้นคว้าวิจัยทางการตลาด ทำแบบสำรวจ ประเมินผล พฤติกรรม
                สถิติและการแบ่งประเภท รูปแบบและกระแสความนิยมด้านการบริโภค
                เพื่อยกระดับการดำเนินธุรกิจให้ดียิ่งขึ้น
                ตลอดจนเพื่อปรับเปลี่ยนเนื้อหาให้ตรงกับความพึงพอใจ
                คาดเดาอุปสงค์ในอนาคต
                เพื่อพิจารณาความมีประสิทธิภาพของแคมเปญส่งเสริมการขาย
              </p>
              <p class="textspaceB">
                <strong>8) เพื่อยกระดับการดำเนินธุรกิจ
                  ผลิตภัณฑ์และการบริการให้ดียิ่งขึ้น</strong>
                เพื่อจัดการและยกระดับการให้บริการ ผลิตภัณฑ์
                และการดำเนินธุรกิจให้แก่ท่านและลูกค้าของเราทั้งหมด
                กลุ่มสยามพิวรรธน์ ซึ่งรวมถึงแต่ไม่จำกัดเพียง พันธมิตรทางธุรกิจ
                เพื่อรับรองมาตรฐานของผลิตภัณฑ์และบริการเรา
                เพื่อการให้คำแนะนำด้านกฎหมาย
                เพื่อจัดทำรายงานภาพรวมของข้อมูลและการใช้จ่ายของลูกค้า
                เพื่อการวินิจฉัยและแก้ไขปัญหาที่เกิดจากผลิตภัณฑ์และบริการที่มีอยู่
                เพื่อติดตาม จัดการ และส่งเสริมประสบการณ์ลูกค้าบนเว็บไซต์
                แอปพลิเคชัน และแพลตฟอร์มของเรา ของลูกค้า
                และเสนอบริการเพิ่มเติมซึ่งอาจมีในอนาคต
              </p>
              <p class="textspaceB">
                <strong>9) เพื่อทราบข้อมูลเกี่ยวกับท่านมากขึ้น</strong> :
                เพื่อทราบข้อมูลมากขึ้นเกี่ยวกับผลิตภัณฑ์และบริการที่ท่านได้รับ
                และผลิตภัณฑ์และบริการอื่นที่ท่านอาจสนใจ ตัวอย่างเช่น
                ด้วยการพิจารณาประเภทของผลิตภัณฑ์และบริการที่ท่านใช้จากบริษัทฯ
                ความถี่ของท่านในการเข้ามายังอาคารของเรา
                ท่านต้องการให้บริษัทฯติดต่อท่านอย่างไรฯลฯ
                เพื่อทราบข้อมูลจากการสำรวจความพึงพอใจ การติชม คำแนะนำ
                และข้อร้องเรียนของท่าน
              </p>
              <p class="textspaceB">
                <strong>10) การปฎิบัติตามหน้าที่ตามกฎข้อบังคับและข้อผูกพัน</strong>
                เพื่อดำเนินการให้เป็นไปตามบทบัญญัติแห่งกฎหมาย กระบวนการทางกฎหมาย
                หรือคำสั่งของหน่วยงานรัฐ ให้ความร่วมมือกับศาล ผู้ควบคุม
                หน่วยงานรัฐ และหน่วยงานที่บังคับใช้กฎหมาย
                ในกรณีที่มีเหตุผลอันควรเชื่อได้ว่าเราต้องดำเนินการดังกล่าวเพื่อปฎิบัติตามกฎหมายและในกรณีที่เราจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านอย่างเคร่งครัดเพื่อปฏิบัติตามบทบัญญัติแห่งกฎหมาย
                กระบวนการทางกฎหมาย หรือคำสั่งของรัฐดังกล่าว
                เพื่อการจัดการเรื่องการจ่ายภาษี การขอคืนภาษีมูลค่าเพิ่ม (VAT
                refunds) และ ค่าธรรมเนียมอื่น ๆ
              </p>
              <p class="textspaceB">
                <strong>11) การปกป้องผลประโยชน์ของเรา</strong>
                เพื่อปกป้องความมั่นคงและความเชื่อมั่นทางธุรกิจของบริษัทฯ
                เพื่อใช้สิทธิหรือปกป้องผลประโยชน์ของเราที่จำเป็นและสามารถทำได้ตามกฎหมาย
                เช่น การตรวจจับ ป้องกัน และตอบโต้ข้อเรียกร้องการทุจริต
                การละเมิดทรัพย์สินทางปัญญา
                เพื่อกระบวนการทางกฎหมายหรือการไม่ปฏิบัติตามกฎหมาย
                เพื่อจัดการและป้องกันความเสียหายแก่ทรัพย์สินและสมบัติของเรา
                เพื่อการปฏิบัติตามข้อกำหนดและเงื่อนไขของเรา
                การประมวลบนระบบรักษาความปลอดภัยและระบบดำเนินงาน IT
                เพื่อตรวจจับและป้องกันการประพฤติที่มิชอบภายในองค์กรซึ่งรวมไปถึงการใช้กล้องวงจรปิด
                เพื่อติดตามเฝ้าระวังเหตุการณ์
                เพื่อป้องกันและรายงานความผิดทางอาญา
              </p>
              <p class="textspaceB">
                <strong>12) การตรวจจับการทุจริต</strong>
                เพื่อตรวจจับและป้องกันการใช้บริการโดยไม่ได้รับอนุญาติ หรือ
                มีการทุจริต หรือ
                ผิดกฎหมายเพื่อดำเนินการตรวจสอบทางกฎหมายหรือกฎข้อบังคับอื่น ๆ
                ที่บังคับใช้ (เช่น
                เพื่อดำเนินการตามกฎหมายป้องกันและปราบปรามการฟอกเงิน) ทั้งนี้
                รวมไปถึง การตรวจสอบและทำบันทึกภายใน และการควบคุมทางธุรกิจอื่น ๆ
              </p>
              <p class="textspaceB">
                <strong>13) การทำธุรกรรมขององค์กร</strong>
                ในกรณีที่มีการขาย การโอน การควบรวม การปรับโครงสร้างองค์กร
                หรือเหตุการณ์อื่น ๆ ที่ใกล้เคียงกัน
                เราอาจโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกอื่น ๆ
                ไม่ว่าจะรายเดียวหรือหลายราย อันเป็นส่วนหนึ่งของการทำธุรกรรมนั้น
                ๆ และ/หรือ
              </p>
              <p class="textspaceB">
                <strong>14) ชีวิต</strong>
                เพื่อป้องกันหรือยับยั้งอันตรายที่เกิดขึ้นต่อชีวิต ร่างกาย
                หรือสุขภาพของบุคคล
                หากท่านไม่สามารถให้ข้อมูลส่วนบุคคลแก่เราเมื่อมีการร้องขอ
                เราอาจไม่สามารถนำเสนอผลิตภัณฑ์หรือบริการของเราแก่ท่านได้
              </p>
              <p class="ptext">
                <strong>3.
                  บุคคลใดที่เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านให้</strong>
              </p>
              <p class="textspace">
                เราอาจเปิดเผย
                หรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลที่สามตามที่ระบุด้านล่าง
                ซึ่งเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
                เพื่อวัตถุประสงค์ตามนโยบายความเป็นส่วนตัวฉบับนี้
                บุคคลที่สามอาจอยู่ภายนอกภายในประเทศไทยหรือนอกประเทศไทย
                โดยท่านสามารถอ่านนโยบายส่วนบุคคลของบุคคลภายนอกเหล่านั้นเพื่อศึกษาข้อมูลเพิ่มเติมเกี่ยวกับวิธีการที่บุคคลภายนอกดังกล่าวเก็บรวบรวม
                ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านได้
                เพราะท่านเองก็อยู่ภายใต้นโยบายความเป็นส่วนตัวเหล่านั้นด้วย
              </p>
              <p class="textspaceB">
                <strong>3.1. กลุ่มสยามพิวรรธน์</strong>
                ในฐานะที่ บริษัท สยามพิวรรธน์ ไซม่อน
                จำกัดเป็นส่วนหนึ่งของกลุ่มสยามพิวรรธน์
                ซึ่งทั้งหมดมีการร่วมมือและแบ่งปันการให้บริการ
                ผลิตภัณฑ์และระบบต่าง ๆ แก่ลูกค้า
                รวมไปถึงแพลตฟอร์มที่เกี่ยวข้องกับเว็บไซต์และระบบอื่น ๆ
                เราอาจมีความจำเป็นที่จะต้องเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบริษัทอื่น
                ๆ ในกลุ่มสยามพิวรรธน์ หรืออนุญาตให้บริษัทอื่น ๆ
                ในกลุ่มสยามพิวรรธน์
                เข้าถึงข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ตามที่ได้ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
                ทั้งนี้ เพื่อให้บริษัทอื่น ๆ
                ในกลุ่มสยามพิวรรธน์สามารถใช้ความยินยอมที่ท่านได้ให้ไว้กับบริษัท
                สยามพิวรรธน์ ไซม่อน จำกัด เป็นฐานได้
                โปรดดูรายชื่อบริษัทและขอบเขตของกิจกรรมภายในกลุ่มสยามพิวรรธน์
              </p>
              <p class="textspaceB">
                <strong>1. บริษัท สยามพิวรรธน์ จำกัด (SPW)</strong>
                บริษัทจำกัดภายใต้กฎหมายไทย โดยมีบริษัทในเครือ ดังนี้:
              </p>
              <p class="textspaceB">บริษัท สยามพิวรรธน์ โฮลดิ้ง จำกัด (SPH)</p>
              <p class="textspaceB">
                บริษัท สยามพิวรรธน์ รีเทล โฮลดิ้ง จำกัด (PRH)
              </p>
              <p class="textspaceB">
                บริษัท สยาม รีเทล คอนวีเนียนซ์ จำกัด (SRC)
              </p>
              <p class="textspaceB">บริษัท สยาม สเปเชียลลิตี้ จำกัด (SST)</p>
              <p class="textspaceB">บริษัท สยาม ซีเล็คเต็ด จำกัด (SSC)</p>
              <p class="textspaceB">บริษัท ดิสคัฟเวอรี่ รีเทล จำกัด (DCR)</p>
              <p class="textspaceB">บริษัท ไพร์ม รีเทล จำกัด (PRC)</p>
              <p class="textspaceB">บริษัท ซูพรีโม จำกัด (SPM)</p>
              <p class="textspaceB">
                บริษัท ดิจิมีเดีย มาร์เก็ตติ้ง จำกัด (DGM)
              </p>
              <p class="textspaceB">บริษัท ซูพรีโม มีเดีย จำกัด (SMM)</p>
              <p class="textspaceB">บริษัท ไพรมอล รีเสิร์ช จำกัด (PMR)</p>
              <p class="textspaceB">บริษัท สยาม กูร์เมต์ โฮลดิ้ง จำกัด (SGH)</p>
              <p class="textspaceB">บริษัท ดิสคัฟเวอรี่ คิทเช่น จำกัด (DCK)</p>
              <p class="textspaceB">
                บริษัท ดิ ไอคอนสยาม เจ้าพระยา ริเวอร์ โฮลดิ้งส์ จำกัด (IRH)
              </p>
              <p class="textspaceB">บริษัทไอคอนสยาม จำกัด (ICON)</p>
              <p class="textspaceB">บริษัทไอคอนสยาม รีเทล จำกัด (IRC)</p>
              <p class="textspaceB">บริษัท ดิ ไอคอน วี จี ไอ จำกัด (TIV)</p>
              <p class="textspaceB">บริษัท ไอซีเอส จำกัด (ICS)</p>
              <p class="textspaceB">
                บริษัท เดอะ เจ้าพระยา ริเวอร์ แอสเสท โฮลดิ้งส์ จำกัด (CAH)
              </p>
              <p class="textspaceB">
                บริษัท สยาม ริเวอร์ โฮลดิ้งส์ จำกัด (SRH)
              </p>
              <p class="textspaceB">บริษัท ไอคอนสยาม ซิกเนเจอร์ จำกัด (ISC)</p>
              <p class="textspaceB">บริษัท ภาคภูมิแผ่นดิน จำกัด (PPP)</p>
              <p class="textspaceB">บริษัท สยามพิวรรธน์ ไซม่อน จำกัด (SPS)</p>
              <p class="textspaceB">บริษัท ลาดกระบัง เรสซิเดนท์ จำกัด (LBR)</p>
              <p class="textspaceB">
                บริษัท สยามโปรเฟสชั่นแนล แมเนจเม้นท์ จำกัด (SPT)
              </p>
              <p class="textspaceB">
                บริษัท สยามอัลไลแอนซ์ แมเนจเม้นท์ จำกัด (SAM)
              </p>
              <p class="textspaceB">
                บริษัท สยาม เอ็นจิเนียริ่ง คอนซัลแทนส์ จำกัด (SEC)
              </p>
              <p class="ptext">
                <strong>
                  SPW และบริษัทในกลุ่มได้ประกอบธุรกิจ และ
                  ดำเนินการพัฒนากธุรกิจประเภทต่างๆดังนี้</strong>
              </p>
              <p class="textspace">
                <strong>1) ธุรกิจพัฒนาอสังหาริมทรัพย์</strong>
                ประกอบธุรกิจที่เกี่ยวกับอสังหาริมทรัพย์ประเภทต่างๆไม่ว่าจะเป็นการให้เช่าพื้นที่ค้าปลีกในศูนย์การค้า
                ให้เช่าพื้นที่อาคารสำนักงาน ได้แก่ สยามเซ็นเตอร์
                สยามดิสคัฟเวอรี่ สยามพารากอน ไอคอนสยาม และ สยามพิวรรธน์ทาวเวอร์
                เพื่อนำเสนอพื้นที่สำนักงาน ศิลปะ แฟชั่น เทคโนโลยี ไลฟ์สไตล์
                และความบันเทิงรูปแบบต่างๆเพื่อตอบสนองความต้องการให้แก่ผู้เช่าทั้งในประเทศ
                และ นานาชาติ
              </p>
              <p class="textspace">
                <strong>2) ร้านค้าปลีก</strong>
                ประกอบธุรกิจค้าปลีกที่มีชื่อเสียง นำเข้าและจำหน่ายผลิตภัณฑ์ต่างๆ
                ซึ่งเจาะกลุ่มลูกค้าที่มีทันสมัยด้วยการนำเสนอสุดพิเศษ
                ไม่ว่าจะเป็น<strong>
                  Loft, The Selected, The Wonder Room, ODS, CAZH, ALAND,
                  Absolute Siam, ICONCRAFT, JSM และ 7-11</strong>
              </p>
              <p class="textspace">
                <strong>3) การสื่อสารการตลาด</strong>
                ประกอบกิจการด้านการสื่อสารการตลาด ตลาดดิจิทัล การโฆษณา
                ส่งเสริมการขาย กิจกรรมระดับโลก และ
                บริการด้านการประชาสัมพันธ์สำหรับกลุ่มสยามพิวรรธน์
                รวมถึงการจัดแอพพลิเคชั่นร้านค้าออนไลน์
                โปรแกรมการบริหารจัดการบัตรของขวัญ (Gift Card) และ รางวัลต่างๆ
              </p>
              <p class="textspace">
                <strong>4) สถานที่จัดงาน</strong>
                ธุรกิจให้บริการพื้นที่ห้องจัดงานกิจกรรม คอนเสิร์ต นิทรรศการ และ
                การประชุมที่ รอยัล พารากอน ฮอลล์
              </p>
              <p class="textspace">
                <strong>5) ธุรกิจด้านอาหารและเครื่องดื่ม</strong>
                ประกอบธุริจร้านค้าปลีกประเภทอาหาร และ เครื่องดื่ม รวมถึงร้าน
                <strong>“My Kitchen”</strong> ที่สยามดิสคัฟเวอรี่
              </p>
              <p class="textspace">
                <strong>6) ธุรกิจ Outlet</strong>
                ดำเนินกิจการ สยามพรีเมี่ยมเอาท์เล็ทกรุงเทพ
                กิจการร่วมค้าระดับพรีเมี่ยมระหว่างกลุ่มสยามพิวรรธน์ และSimon
                Property Group
              </p>

              <p class="textspace">
                <strong>7) บริหารจัดการอาคาร</strong>

                ประกอบธุรกิจด้านการริการรักษาความปลอดภัย ให้คำปรึกษาด้านวิศวกรรม
                การเพิ่มผลผลิตจากสินทรัพย์ด้านอสังหาริมทรัพย์ การบริหารงบประมาณ
                ลดความเสี่ยงด้านสุขภาพ และ เสริมสร้างความปลอดภัย
                ตลอดจนสร้างความเชื่อมั่นให้แก่ผู้เช่า
              </p>
              <p class="textspace">
                <strong>2. บริษัท สยามพารากอน รีเทล จำกัด</strong>("SPR"),
                บริษัทจำกัดภายใต้กฎหมายไทย โดยมีบริษัทในเครือ ดังนี้:
              </p>
              <p class="textspaceB">
                <strong>บริษัท เอส พี อาร์ ฟู้ด ซิตี้ จำกัด</strong>
              </p>
              <p class="textspaceB">
                <strong>บริษัท พารากอน ฟู้ด ฮอลล์ จำกัด</strong>
              </p>
              <p class="ptext">
                <strong>SPR และบริษัทในกลุ่มได้ประกอบธุรกิจ และ
                  ดำเนินการพัฒนากธุรกิจประเภทต่างๆดังนี้
                </strong>
              </p>
              <p class="textspaceB">
                <strong>1) ห้างสรรพสินค้า</strong>
                เปิดดำเนินการห้างสรรพสินค้าพารากอน โดยมี Gourmet, Shoes Bag
                Salon, Paragon Venue, Be trend, Paragon Men, Power Mall และ
                Paragon Living
              </p>
              <p class="textspaceB">
                <strong>2) ศูนย์อาหาร</strong>
                ธุรกิจศูนย์อาหาร และ ให้เช่าพื้นที่เพื่อจำหน่ายอาหารแบบ Take
                Home
              </p>
              <p class="textspace">
                <strong>3. บริษัท ทรู ไอคอนสยาม จำกัด = TIC</strong>ประกอบกิจการให้เช่าพื้นที่ห้องจัดงานอีเว้นท์ กิจกรรม
                คอนเสิร์ต
                งานแสดงสินค้า และ การประชุมที่ ทรู ไอคอน ฮอลล์
              </p>
              <p class="textspace">
                <strong>4. บริษัท สยาม ริเวีย จำกัด ("SRV")</strong>SRV
                ประกอบกิจการจำหน่ายอาหาร และ เครื่องดื่มที่ร้าน Blue By Alain
                Ducasse
              </p>
              <p class="textspace">
                <strong>5. บริษัท สยาม ทาคาชิมาย่า (ประเทศไทย) จำกัด ("STK") STK
                  ดำเนินกิจการห้าง Siam Takashimaya</strong>
                ซึ่งเป็นห้างสรรพสินค้าตั้งอยู่ในโครงการไอคอนสยาม
                ซึ่งเป็นห้างฯที่ผสมผสานระหว่างห้างสรรพสินค้าไทย และ
                ห้างสรรพสินค้า Takashimaya ของประเทศญี่ปุ่น
              </p>
              <p class="textspace">
                <strong>6. บริษัท ดิ ไอคอนสยาม เรสซิเดนซ์ คอร์ปอเรชั่น จำกัด
                  ICR</strong>
              </p>
              <p class="textspaceB">
                <strong>1) ICR1</strong>
                ดำเนินธุรกิจการพัฒนาและจำหน่ายที่พักอาศัยโครงการ แมกโนเลียส์
                วอเตอร์ฟร้อนท์ เรสซิเดนซ์ ไอคอนสยาม
              </p>
              <p class="textspace">
                <strong>7. บริษัท ดิ ไอคอนสยาม ซูเปอร์ลักซ์ เรสซิเดนซ์
                  คอร์ปอเรชั่นจำกัด ("ICR2") ICR1</strong>
                ดำเนินธุรกิจการพัฒนาและจำหน่ายที่พักอาศัยโครงการ แมนดาริล
                ออเรียนทอล เรสซิเดนซ์
              </p>
              <p class="textspace">
                <strong>8. บริษัท ดิ ไอคอน โปรเฟลชั่นแนล แมเนจเม้นท์ จำกัด
                  (“IPM”)</strong>
                IPM ดำเนินธุรกิจให้บริการบริหารจัดการอาคาร และอสังหาริมทรพย์
                ประกอบธุรกิจด้านการริการรักษาความปลอดภัย ให้คำปรึกษาด้านวิศวกรรม
                การเพิ่มผลผลิตจากสินทรัพย์ด้านอสังหาริมทรัพย์ การบริหารงบประมาณ
                ลดความเสี่ยงด้านสุขภาพ และ เสริมสร้างความปลอดภัย
                ตลอดจนสร้างความเชื่อมั่นให้แก่เจ้าของร่วมในอาคารชุด
              </p>
              <p class="textspaceB">
                <strong>3.2. ผู้ให้บริการของเรา</strong>
                บริษัทฯอาจใช้บริการบริษัท ตัวแทน
                หรือผู้รับจ้างอื่นเพื่อให้บริการต่าง ๆ
                แทนบริษัทฯหรือเพื่อช่วยในการจัดหาผลิตภัณฑ์และบริการให้แก่ท่าน
                บริษัทฯอาจแบ่งปันข้อมูลส่วนบุคคลของท่านให้แก่ผู้ให้บริการหรือผู้จัดหาผลิตภัณฑ์บริการจากภายนอก
                ซึ่งรวมถึง แต่ไม่จำกัดเฉพาะ (1) ธนาคาร และ สถาบันทางการเงิน (2)
                ผู้ให้บริการด้านโลจิสติกส์และการขนส่ง (3)
                บริษัทที่ให้บริการด้านการตลาด สื่อโฆษณา การออกแบบ การสร้างสรรค์
                และการสื่อสาร (4) บริษัทที่ให้บริการด้านการจัดงาน (5)
                ผู้ให้บริการด้านโทรคมนาคมและการสื่อสาร (6)
                ผู้ให้บริการด้านธุรการจากภายนอก (7)
                ผู้ให้บริการด้านการจัดเก็บข้อมูลและบริการคลาวด์ (8) บริษัทประกัน
                (9) ผู้ให้บริการด้านการบริหารความเสี่ยง (10) บริษัทนำเที่ยว (11)
                ผู้ให้บริการด้านการปรับปรุงอาคาร และ/หรือ (12)
                ผู้ให้บริการด้านอินเทอร์เน็ต ซอฟต์แวร์ สื่อดิจิทัล
                ผู้ให้บริการด้านเทคโนโลยีสารสนเทศและบริษัทผู้ให้บริการสนับสนุนด้านเทคโนโลยีสารสนเทศ
                ในระหว่างการให้บริการต่าง ๆ ดังกล่าว
                ผู้ให้บริการอาจจะต้องเข้าถึงข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม
                เราจะให้ข้อมูลส่วนบุคคลแก่ผู้ให้บริการของเราเพียงเท่าที่จำเป็นสำหรับการให้บริการดังกล่าวเท่านั้น
                และจะขอให้ผู้ให้บริการไม่ใช้ข้อมูลของท่านเพื่อวัตถุประสงค์อื่นแต่อย่างใด
                เรารับรองว่าผู้ให้บริการของเราจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลตามที่กฎหมายระบุไว้
              </p>
              <p class="textspaceB">
                <strong>3.3. พันธมิตรทางธุรกิจของเรา</strong>

                เราอาจโอนข้อมูลส่วนบุคคลของท่านให้แก่พันธมิตรทางธุรกิจของเรา
                เราอาจมีการดำเนินธุรกิจร่วมกับพันธมิตรทางธุรกิจของเรา (เช่น
                ผู้เช่าร้านค้า พันธมิตรทางธุรกิจเพื่อการจัดโปรแกรมการสะสมคะแนน
                พันธมิตรทางธุรกิจบัตรเครดิต)
                ซึ่งบริษัทฯอาจเสนอผลิตภัณฑ์หรือบริการซึ่งมีร่วมกัน หรือ
                อาจเสนอผลิตภัณฑ์หรือบริการของพันธมิตรทางธุรกิจเอง
              </p>
              <p class="textspaceB">
                <strong>3.4. เว็บไซต์ต่างๆ ในสื่อสังคมออนไลน์</strong>
                เราอาจมีสื่อโฆษณาซึ่งเชื่อมต่อไปยังเว็บไซต์อื่น ๆ
                แอปพลิเคชันบนโทรศัพท์มือถือ ช่องทางสื่อสังคมออนไลน์
                ช่องทางการสื่อสารทางออนไลน์ ซึ่งแพลตฟอร์มต่าง ๆ
                ดังกล่าวอาจมีข้อกำหนดในการใช้งานหรือนโยบายเกี่ยวกับการใช้งาน
                และนโยบายความเป็นส่วนตัวซึ่งแตกต่างไปจากนโยบายความเป็นส่วนตัวและข้อกำหนดในการใช้งานของเรา
                เราขอแนะนำให้ท่านทบทวนข้อกำหนดในการใช้งานและนโยบายความเป็นส่วนตัวบนแพลตฟอร์มข้างต้นด้วยตัวเอง
              </p>
              <p class="textspaceB">
                <strong>3.5. บุคคลภายนอกตามที่กฎหมายกำหนด</strong>
                ในบางกรณี
                เราอาจจำเป็นที่จะต้องเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามกฎหมาย
                หรือกฎข้อบังคับ ซึ่งรวมถึง
                การปฏิบัติตามหน่วยงานที่บังคับใช้กฎหมาย ศาล ผู้ดูแลควบคุม
                หน่วยงานรัฐ หรือบุคคลภายนอกอื่น ๆ
                ในกรณีที่เราเชื่อว่าจำเป็นจะต้องปฏิบัติตามหน้าที่ตามกฎหมายหรือกฎข้อบังคับทางกฎหมาย
                หรือเพื่อการปกป้องสิทธิของเรา สิทธิของบุคคลอื่น
                หรือเพื่อความปลอดภัยของบุคคล หรือเพื่อตรวจสอบ ป้องกัน
                หรือจัดการเกี่ยวกับปัญหาการทุจริต
                หรือด้านความมั่นคงหรือความปลอดภัย
              </p>
              <p class="textspaceB">
                <strong>3.6 ที่ปรึกษามืออาชีพด้านต่าง ๆ </strong>
                เช่น ผู้ให้คำปรึกษาด้านกฎหมาย ผู้สอบบัญชี
                และผู้ให้คำปรึกษาด้านอื่นซึ่งข้องเกี่ยวกับการดำเนินงานทางธุรกิจ
                และ การพิพาทหรือเรียกร้องทางกฎหมาย
              </p>
              <p class="textspaceB">
                <strong>3.7 ผู้รับโอนสิทธิและ/หรือหน้าที่</strong>

                บุคคลภายนอกในฐานะผู้รับโอนสิทธิและ/หรือหน้าที่
                ในกรณีมีการปรับโครงสร้างองค์กร การควบรวมกิจการ
                การโอนกิจการไม่ว่าจะบางส่วน หรือทั้งหมด
                ผู้รับโอนสิทธิและ/หรือหน้าที่ของเราจะปฏิบัติตามนโยบายความเป็นส่วนตัวฉบับนี้เพื่อเป็นการเคารพต่อข้อมูลส่วนบุคคลของท่าน
              </p>
              <p class="textspace">
                <strong>4. การโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ</strong>
                เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกหรือเซิร์ฟเวอร์ที่อยู่ในต่างประเทศซึ่งประเทศปลายทางอาจมี
                หรืออาจไม่มีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เท่าเทียมกัน
                ทั้งนี้ เราจะดำเนินการตามขั้นตอนและมาตรการต่าง ๆ
                เพื่อทำให้มั่นใจว่าข้อมูลส่วนบุคคลของท่านจะถูกโอนอย่างปลอดภัยและบุคคลที่รับโอนข้อมูลนั้นมีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เหมาะสมหรือกรณีอื่น
                ๆ ตามที่กฎหมายกำหนด
                และเราจะขอความยินยอมจากท่านเพื่อการโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศหากจำเป็นต้องปฏิบัติตามที่กฎหมายกำหนด
              </p>
              <p class="textspaceB">
                <strong>5. ระยะเวลาในการที่เราเก็บข้อมูลส่วนบุคคลของท่าน</strong>
                เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านในระยะเวลาเท่าที่จำเป็นอย่างสมเหตุสมผล
                เพื่อให้บรรลุตามวัตถุประสงค์ที่เราได้รับข้อมูลส่วนบุคคลนั้นมา
                และเพื่อปฏิบัติตามภาระหน้าที่ทางกฎหมายและกฎข้อบังคับต่าง ๆ
                อย่างไรก็ตาม
                เราอาจเก็บข้อมูลส่วนบุคคลของท่านนานขึ้นหากจำเป็นตามกฎหมายที่ใช้บังคับ
              </p>
              <p class="textspaceB">
                <strong>6. วิธีการใช้คุกกี้ และไฟล์แคช (cache file)</strong>

                เมื่อท่านเข้าเยี่ยมเว็บไซต์และแอปพลิเคชัน เราจะทำการติดตาม เก็บ
                และบันทึกข้อมูลส่วนบุคคลบางประการ
                โดยการใช้คุกกี้หรือเทคโนโลยีเพื่อติตดามอื่น ๆ
                สำหรับแอปพลิเคชันนั้น
                คุกกี้จะถูกใช้ต่อเมื่อท่านลงชื่อเข้าใช้บัญชีบนแอปพลิเคชัน
                โดยตัวคุกกี้จะทำการจดจำท่านไว้
                เพื่อให้ไม่ต้องกรอกชื่อผู้ใช้และรหัสทุกครั้งที่จะเข้าใช้แอปพลิเคชัน
                อย่างไรก็ตาม คุกกี้จะหยุดทำงานทันทีเมื่อท่านออกจากระบบ
                และในกรณีที่เราไม่มีอำนาจควบคุมตัวคุกกี้
                เราจะไม่มีการเก็บข้อมูลจากคุกกี้หรือการเข้าถึงคุกกี้
              </p>
              <p class="textspaceB">
                เราจะใช้ข้อมูลแคชเพื่อการบันทึกข้อมูลของท่าน
                ในกรณีที่ท่านใช้เครื่องมืออื่นเพื่อต่อไปยังเว็บไซต์หรือแอปพลิเคชันของเรา
                ข้อมูลของท่านอาจถูกเก็บและบันทึกไว้ในรูปแบบไฟล์แคช (cache file)
                หรือ
                ส่วนข้อมูลของท่านอาจถูกคัดลอกบนคอมพิวเตอร์หรือโทรศัพท์มือถือสำหรับการใช้ในคราวถัดไป
                ในกรณีที่เราไม่มีอำนาจควบคุมข้อมูลหรือการเข้าถึงไฟล์แคช
              </p>
              <p class="textspace">
                <strong>7. สิทธิของเจ้าของข้อมูลส่วนบุคคล</strong>
                ภายใต้บทบัญญัติแห่งกฎหมายและข้อยกเว้นตามกฎหมายที่เกี่ยวข้อง
                ท่านอาจมีสิทธิตามที่ระบุไว้ดังต่อไปนี้
              </p>
              <p class="textspaceB">
                <strong>1) การเข้าถึง :</strong>
                ท่านอาจมีสิทธิในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลที่เราเก็บรวบรวม
                ใช้หรือเปิดเผยเกี่ยวกับท่าน ทั้งนี้
                เพื่อความเป็นส่วนตัวและความปลอดภัยของท่าน
                เราอาจขอให้ท่านพิสูจน์ตัวตนของท่านก่อนจะให้ข้อมูลตามที่ท่านขอ
              </p>
              <p class="textspaceB">
                <strong>2) การแก้ไขให้ถูกต้อง :</strong>
                ท่านอาจมีสิทธิขอให้มีการดำเนินการแก้ไขข้อมูลส่วนบุคคลที่ไม่ครบถ้วน
                ไม่แม่นยำ สามารถทำให้เข้าใจผิด หรือไม่เป็นปัจจุบัน
                ซึ่งเราได้เก็บรวบรวม ใช้หรือเปิดเผยเกี่ยวกับท่าน
              </p>
              <p class="textspaceB">
                <strong>3) การโอนย้ายข้อมูล :</strong>
                ท่านอาจมีสิทธิขอรับข้อมูลส่วนบุคคลที่เรามีเกี่ยวกับท่านในรูปแบบที่มีการจัดระเบียบแล้วและสามารถอ่านได้ในรูปแบบอิเล็กทรอนิกส์
                และเพื่อส่งหรือโอนข้อมูลดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น
                โดยต้องเป็น (ก) ข้อมูลส่วนบุคคลที่ท่านได้ให้กับเรา และ (ข)
                กรณีที่เราได้รับความยินยอมจากท่านในการเก็บรวบรวม ใช้
                หรือเปิดเผยหรือเพื่อปฏิบัติตามสัญญาที่เรามีกับท่าน
              </p>
              <p class="textspaceB">
                <strong>4) การคัดค้าน :</strong>
                ท่านอาจมีสิทธิคัดค้านการเก็บรวบรวม
                ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน เช่น
                การคัดค้านการตลาดแบบตรง
              </p>
              <p class="textspaceB">
                <strong>5) การขอให้ระงับการใช้ : </strong>
                ท่านอาจมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลของท่านในบางกรณี
              </p>
              <p class="textspaceB">
                <strong>6) การถอนความยินยอม : </strong>
                สำหรับวัตถุประสงค์ที่ท่านได้ให้ความยินยอมให้เราเก็บรวบรวม
                ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                ท่านมีสิทธิที่จะถอนความยินยอมของท่าน ณ เวลาใด ก็ได้
              </p>
              <p class="textspaceB">
                <strong>7) ท่านอาจมีสิทธิขอให้เราดำเนินการลบ : </strong>
                หรือทำให้ข้อมูลส่วนบุคคลของท่านที่เราเก็บรวบรวม ใช้หรือเปิดเผย
                เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล
                เว้นเสียแต่ว่า
                การเก็บรักษาข้อมูลดังกล่าวของเรานั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย
                หรือเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย เพื่อการใช้
                หรือการปกป้องสิทธิเรียกร้องตามกฎหมาย
              </p>
              <p class="textspaceB">
                <strong>8) การยื่นเรื่องร้องเรียน : </strong>
                ท่านอาจมีสิทธิยื่นเรื่องร้องเรียนไปยังหน่วยงานที่มีอำนาจในกรณีที่ท่านเชื่อว่าการเก็บรวบรวม
                ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของเรานั้นไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่บังคับใช้
              </p>
              <p class="textspace">
                <strong>8. รายละเอียดการติดต่อเรา</strong>
                หากท่านมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน
                หรือหากท่านมีข้อสงสัยเกี่ยวกับข้อมูลส่วนบุคคลของท่านภายใต้นโยบายความเป็นส่วนตัวฉบับนี้
                โปรดติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเรา ที่
              </p>
              <p class="textspaceB">
                <strong>1) ชื่อบริษัท</strong>
              </p>
              <p class="textspaceB">บริษัท สยามพิวรรธน์ ไซม่อน จำกัด</p>
              <p class="textspaceB">
                989 หมู่ที่ 14 ตำบลบางเสาธง อำเภอบางเสาธงจังหวัดสมุทรปราการ10540
                เบอร์โทรศัพท์ : 02-610-8333 อีเมล์ : dpoteam@siampiwat.com
              </p>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-col align="center" justify="center">
                <v-btn class="white--text" color="primary" @click="
          (agreement = true),
          (dialogFirst = false),
          (checkbox = true),
          (dialogPolicy = true)
          ">
                  ยอมรับเงื่อนไข
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- ---------dialog permission------------------------->

        <div class="text-center">
          <v-dialog v-model="dialogPolicy" width="600" persistent>
            <v-card>
              <br />
              <p class="subtitle-1">
                <strong>หนังสือให้ความยินยอม</strong>
                <!-- (ระยะเวลากิจกรรมตั้งแต่ 1 ม.ค. - 26 มิ.ย. 63 จับรางวัล 4 ครั้ง และทบฉลากทุกครั้ง) -->
              </p>

              <v-card-text>
                <p align="center">
                  <strong><u></u></strong>
                </p>
                <p class="ptext">
                  ขอเชิญชวนท่านมาร่วมสัมผัสนวัตกรรมการใช้ชีวิตและการใช้จ่ายอย่างสร้างสรรค์
                  โดยการกดเลือกที่ช่องดังต่อไปนี้
                </p>
                <p class="ptext">
                  1. ข้าพเจ้าได้อ่าน รับทราบ และยอมรับนโยบายความเป็นส่วนตัว
                  https://www.siampremiumoutlets.com/en/privacy
                </p>
                <p class="ptext">
                  2.
                  ข้าพเจ้าขอให้ความยินยอมในการรับกิจกรรมทางการตลาดและการติดต่อสื่อสารจากบริษัท
                  สยามพิวรรธน์ ไซม่อน จำกัด, กลุ่มสยามพิวรรธน์, บริษัทในเครือ,
                  บริษัทย่อย, บริษัทในกลุ่ม, ผู้เช่า
                  และผู้ใช้บริการพื้นที่ของกลุ่มสยามพิวรรธน์
                  (ซึ่งต่อไปจะเรียกรวมว่า
                  “<strong>กลุ่มบริษัทสยามพิวรรธน์</strong>”)
                  ซึ่งกลุ่มบริษัทสยามพิวรรธน์ไม่สามารถที่จะยกอ้างฐานทางกฎหมายตามที่ระบุในนโยบายความเป็นส่วนตัวได้
                  (โปรดดูรายละเอียดในนโยบายความเป็นส่วนตัวตาม link
                  ที่ปรากฏด้านบน) ทั้งนี้
                  รายชื่อกลุ่มสยามพิวรรธน์อาจมีการปรับเพิ่มขึ้นหรือลดลงได้ในภายหน้า
                  ทั้งนี้ บริษัทฯ
                  จะแจ้งรายชื่อที่เพิ่มขึ้นให้ท่านทราบทางไปรษณีย์อิเล็กทรอนิกส์
                  (e-mail), หนังสือ, ข้อความทางโทรศัพท์ (SMS),
                  หรือช่องทางอื่นที่บริษัทฯ เห็นว่าเหมาะสม
                </p>
                <p class="ptext">
                  3.
                  ข้าพเจ้าขอให้ความยินยอมในการรับกิจกรรมทางการตลาดและการติดต่อสื่อสารเกี่ยวกับ
                  และ/หรือ จากพันธมิตรทางธุรกิจของกลุ่มสยามพิวรรธน์ ซึ่งบริษัทฯ
                  หรือกลุ่มบริษัทสยามพิวรรธน์ไม่สามารถที่จะยกอ้างฐานทางกฎหมายตามที่ระบุในนโยบายความเป็นส่วนตัวได้
                  (โปรดดูรายละเอียดในนโยบายความเป็นส่วนตัวตาม link
                  ที่ปรากฏด้านบน)
                </p>
                <p class="ptext">
                  โดยข้าพเจ้าขอรับกิจกรรมทางการตลาดและการติดต่อสื่อสารจากกลุ่มบริษัทสยามพิวรรธน์
                  และ/หรือ จากพันธมิตรทางธุรกิจของกลุ่มสยามพิวรรธน์ ผ่านช่องทาง
                </p>
              </v-card-text>

              <v-divider></v-divider>
              <v-list-item>
                <v-checkbox v-model="policy.email" @click="!policy.email"></v-checkbox>

                <v-list-item-subtitle class="text-policy">
                  ไปรษณีย์อิเล็กทรอนิกส์(E-Mail)
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-checkbox v-model="policy.terms" @click="!policy.terms"></v-checkbox>
                <v-list-item-subtitle class="text-policy">
                  หนังสือ (Terms and Conditions)</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-checkbox v-model="policy.sms" @click="!policy.sms"></v-checkbox>
                <v-list-item-subtitle class="text-policy">ข้อความทางโทรศัพท์ (SMS)</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-checkbox v-model="policy.voice" @click="!policy.voice"></v-checkbox>
                <v-list-item-subtitle class="text-policy">ข้อความเสียง (Voice Mail)</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-checkbox v-model="policy.other" @click="!policy.other"></v-checkbox>
                <v-list-item-subtitle class="text-policy">อื่นๆ
                </v-list-item-subtitle>
              </v-list-item>

              <!-- ------ text notificate check policy----- -->
              <p class="subtitle-1">
                <strong>{{ textCheckPolicy }}</strong>
              </p>

              <v-card-actions>
                <v-col align="center" justify="center">
                  <v-btn color="primary" @click="policyCheck"> accept </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <!-- --------------------------------------------------->
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment";
import Axios from "../config/axios";
import BaseTimer from "../components/CountDown";

export default {
  components: { BaseTimer, },
  data: () => ({
    show: true,
    dialogMaximun: true,
    componentKey: 0,
    dialogPolicy: false,
    dialogFirst: true,
    policy: {
      email: true,
      terms: true,
      sms: true,
      voice: true,
      other: true,
    },
    textOTP: "กรุณากรอกรหัส OTP ด้วยค่ะ",
    textCheckPolicy: "",

    dialogPhoneNumberDulicate: false,
    dialogInsertOTP: false,
    dialog: false,
    formValid: true,
    name: "",
    nameRules: [(v) => !!v || "กรุณากรอกชื่อ-นามสกุล"],
    date: null,
    dateRules: [(v) => !!v || "กรุณาระบุวันเกิด"],
    gender: "",
    genderRules: [(v) => !!v || "กรุณาเลือกเพศ"],
    email: "",
    emailRules: [
      (v) => (v ? /.+@.+\..+/.test(v) || "อีเมลไม่ถูกต้อง" : v !== null),
    ],
    mobile: "",
    mobileRules: [
      (v) => !!v || "กรุณากรอกเบอร์มือถือ",
      (v) => /^(08|06|09)\d{8}$/.test(v) || "เบอร์มือถือไม่ถูกต้อง",
    ],
    otpRules: [
      (v) => !!v || "กรุณากรอกรหัส OTP",
      (v) => /^\d{6}$/.test(v) || "รหัส OTP ไม่ถูกต้อง",
    ],
    province: null,
    provinceItems: [
      "กรุงเทพมหานคร",
      "กระบี่",
      "กาญจนบุรี",
      "กาฬสินธุ์",
      "กำแพงเพชร",
      "ขอนแก่น",
      "จันทบุรี",
      "ฉะเชิงเทรา",
      "ชลบุรี",
      "ชัยนาท",
      "ชัยภูมิ",
      "ชุมพร",
      "เชียงราย",
      "เชียงใหม่",
      "ตรัง",
      "ตราด",
      "ตาก",
      "นครนายก",
      "นครปฐม",
      "นครพนม",
      "นครราชสีมา",
      "นครศรีธรรมราช",
      "นครสวรรค์",
      "นนทบุรี",
      "นราธิวาส",
      "น่าน",
      "บึงกาฬ",
      "บุรีรัมย์",
      "ปทุมธานี",
      "ประจวบคีรีขันธ์",
      "ปราจีนบุรี",
      "ปัตตานี",
      "พระนครศรีอยุธยา",
      "พังงา",
      "พัทลุง",
      "พิจิตร",
      "พิษณุโลก",
      "เพชรบุรี",
      "เพชรบูรณ์",
      "แพร่",
      "พะเยา",
      "ภูเก็ต",
      "มหาสารคาม",
      "มุกดาหาร",
      "แม่ฮ่องสอน",
      "ยะลา",
      "ยโสธร",
      "ร้อยเอ็ด",
      "ระนอง",
      "ระยอง",
      "ราชบุรี",
      "ลพบุรี",
      "ลำปาง",
      "ลำพูน",
      "เลย",
      "ศรีสะเกษ",
      "สกลนคร",
      "สงขลา",
      "สตูล",
      "สมุทรปราการ",
      "สมุทรสงคราม",
      "สมุทรสาคร",
      "สระแก้ว",
      "สระบุรี",
      "สิงห์บุรี",
      "สุโขทัย",
      "สุพรรณบุรี",
      "สุราษฎร์ธานี",
      "สุรินทร์",
      "หนองคาย",
      "หนองบัวลำภู",
      "อ่างทอง",
      "อุดรธานี",
      "อุทัยธานี",
      "อุตรดิตถ์",
      "อุบลราชธานี",
      "อำนาจเจริญ",
    ],
    categorys: null,
    categoryItems: [
      "สินค้าแบรนด์เนม",
      "สินค้าแฟชั่น",
      "สินค้าด้านกีฬา",
      "อุปกรณ์ IT",
      "สินค้าความงาม",
      "อื่นๆ",
    ],
    checkbox: false,
    verifyRequest: {
      requestId: null,
      ref_code: null,
      code: null,
      requestId2st: null,
    },
    isDisabled: false,
  }),

  computed: {
    computedDateFormattedMomentjs() {
      if (this.date) {
        if (moment(this.date).isLeapYear()) {
          const day = moment(this.date).format("DD MMM YYYY");
          const daySubString = day.substring(0, 6);
          if (daySubString == "29 Feb") {
            return moment(this.date)
              .locale("th")
              .add(543, "y")
              .format("29 ก.พ. YYYY");
          } else {
            return moment(this.date)
              .locale("th")
              .add(543, "y")
              .format("DD MMM YYYY");
          }
        } else {
          return moment(this.date)
            .locale("th")
            .add(543, "y")
            .format("DD MMM YYYY");
        }
      } else {
        return "";
      }
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    componentKey() {
      this.$forceUpdate();
    },
  },

  methods: {
    async validate() {
      if (!this.$refs.form.validate()) return
      this.countdown = true;
      const checkMobileRegister = await Axios.post("/mobiles/", {
        mobile: this.mobile,
      });

      if (!checkMobileRegister.data.result) {
        const { data } = await Axios.post(`/verify/request`, {
          mobile_no: this.mobile,
        });
        this.componentKey += 1;
        this.dialogMaximun = true;
        this.dialogInsertOTP = true;

        if (data.status) {
          this.verifyRequest.requestId = data.data.request_id;
          this.verifyRequest.ref_code = data.data.ref_code;
          this.textOTP = "กรุณากรอกรหัส OTP ด้วยค่ะ";
          setTimeout(() => this.dialogInsertOTP = false, 1000 * 60 * 10);
        } else {
          this.textOTP = "คุณขอ OTP มากเกินไปแล้วค่ะ!!";
          setTimeout(() => this.dialogInsertOTP = false, 1000 * 60 * 10);
        }
      } else {
        this.dialogPhoneNumberDulicate = true;
      }
    },

    async confirmOTP() {
      const otpCheck = await Axios.post("/verify/check", this.verifyRequest);

      if (otpCheck.data.status === 0) {
        this.verifyRequest.requestId2st = otpCheck.data.request_id;
        const dataUser = {
          name: this.name,
          birthDay: this.date,
          gender: this.gender,
          email: this.email,
          mobile: this.mobile,
          province: this.province,
          categories: this.categorys,
          requestID_1st: this.verifyRequest.requestId,
          requestID_2nd: this.verifyRequest.requestId2st,
          ref_code: this.verifyRequest.ref_code,
          code_OTP: this.verifyRequest.code,
          policy_email: this.policy.email,
          policy_terms: this.policy.terms,
          policy_sms: this.policy.sms,
          policy_voice: this.policy.voice,
          policy_other: this.policy.other,
        };
        await Axios.post(`/register`, dataUser);
        this.$router.push({ name: "thankyou" });
        this.dialogInsertOTP = false;
      } else if (otpCheck.data.status === 8) {
        this.textOTP = "รหัส OTP หมดอายุแล้ว!!";
      } else if (otpCheck.data.status === 9) {
        this.dialogMaximun = false;
        this.textOTP = "กรอกรหัส OTP ผิดเกินกำหนด กรุณากด SUBMIT ใหม่";
        this.verifyRequest.code = "";
        setTimeout(() => {
          this.dialogInsertOTP = false;
        }, 3500);
      } else {
        this.textOTP = "กรอกรหัส OTP ไม่ถูกต้อง!!";
        this.verifyRequest.code = "";
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    save(date) {
      this.$refs.menu.save(date);
    },

    closeDialog() {
      this.dialogInsertOTP = false;
      this.countdown = false;
      this.componentKey += 1;
    },
    policyCheck() {
      const check = {
        other: this.policy.other,
        voice: this.policy.voice,
        sms: this.policy.sms,
        terms: this.policy.terms,
        email: this.policy.email,
      };
      const result = Object.values(check).some((item) => item === true);
      if (!result) {
        this.textCheckPolicy = "กรุณาเลือกอย่างน้อย 1 อย่าง";
      } else {
        this.dialogPolicy = false;
      }
    },
  },
};
</script>

<style>
.dialog {
  font-family: "Kanit", sans-serif;
}

.v-list-item__subtitle {
  font-size: 1rem !important;
  text-align: left;
}

.v-list-item__title,
.v-application .subtitle-1 {
  font-size: 1.8 rem !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Kanit", sans-serif !important;
}

.v-application .purple.darken-1 {
  background-color: #000 !important;
  border-color: #000 !important;
}

.ptext {
  text-align: left;
  font-family: "Kanit", sans-serif;
  color: #000;
}

.pmodal {
  text-align: left;
  font-family: "Kanit", sans-serif;
  font-size: 1.2rem;
  color: #000;
}

.textspace {
  text-align: left;
  text-indent: 20px;
  color: #000;
}

.textspaceB {
  text-align: left;
  text-indent: 30px;
  color: #000;
}

.text-policy {
  font-family: "Kanit", sans-serif;
  font-size: 110%;
}

.v-dialog>.v-card>.v-card__title {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  padding: 16px 24px 10px;
  font-family: "Kanit", sans-serif !important;
}

.v-card__title {
  font-size: 1.25rem;
  font-weight: 500;

  line-height: 2rem;
}

.responsive {
  width: 60% !important;
  height: auto;
}

.res {
  width: 100% !important;
  height: auto;
}

.v-application .headline {
  font-size: 1.5rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "Kanit", sans-serif !important;
}

.v-list-item__subtitle {
  font-size: 1rem !important;
  text-align: center;
}
</style>